import React from "react"
import logoDescription from "../assets/inSymphonia_desc.avif";
import Symbol from "../assets/Symbol.avif"
import "./TheLogo.css";

export default function TheLogo() {
  return (
    <div className="the-logo-page">
      <section className="the-logo-hero">
        <div className="container the-logo-container">
          <div className="the-logo-image-wrapper">
            <img
              src={logoDescription}
              alt="Description and structure of the Symphonia logo"
              className="the-logo-image"
            />
          </div>

          <div className="the-logo-content">
            <h2>
              The instruments are ready.
              <br />
              The score is written.
              <br />
              The conductire lifts the hand.
            </h2>
            <h1 className="mt-3">Leave the machine. Return to your image.</h1>

            <div className="the-logo-divider">
              <img src={Symbol}/>
            </div>
            <p>
              NHI Symphonia. The voice that was always there. Now, finally, heard.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
